<script>import { mdiMenu } from "@mdi/js";
import Breadcrumb from "./Breadcrumb.svelte";
import Button from "./Button.svelte";
import { browser } from "../utils/env.js";
import { cls } from "../utils/styles.js";
import { getComponentClasses } from "./theme.js";
import { getSettings } from "./index.js";
export let title = "";
export let menuIcon = mdiMenu;
let className = void 0;
export { className as class };
export let head = true;
const { showDrawer } = getSettings();
const settingsClasses = getComponentClasses("AppBar");
$: titleString = Array.isArray(title) ? title.filter((x) => x).join(" \u203A ") : title.toString();
$: if (browser && head) {
  document.title = titleString;
}
function toggleMenu() {
  $showDrawer = !$showDrawer;
}
</script>

<header
  class={cls('AppBar', 'px-4 flex items-center relative z-50', settingsClasses.root, className)}
>
  {#if menuIcon}
    <slot name="menuIcon" {toggleMenu} isMenuOpen={$showDrawer}>
      <Button icon={menuIcon} on:click={toggleMenu} class="p-3" />
    </slot>
  {/if}

  {#if $$slots.title}
    <slot name="title" />
  {:else}
    <div class="ml-2 text-lg font-medium">
      {#if typeof title === 'string' || typeof title === 'number'}
        {title}
      {:else}
        <Breadcrumb items={title} class="gap-2" />
      {/if}
    </div>
  {/if}

  <slot />

  <div class="flex-1 grid justify-end">
    <slot name="actions" />
  </div>
</header>

<svelte:head>
  {#if head}
    <title>{titleString}</title>
  {/if}
</svelte:head>
